import { registerCardRenderer } from '../components/conversations/cards/registry.js';
import { registerCoreCardRenderers } from '../components/conversations/cards/core-cards.js';
import { getPanelType, registerPanelType } from '../components/context-panel/registry.js';
import { clientModuleRegistry } from './registry.js';
import { coreClientModule } from './core/index.js';
import { codeClientModule } from '../../../modules/code/client/index.js';
import { financeClientModule } from '../../../modules/finance/client/index.js';

// Runs once at app startup before router + sidebar read from the registry.
// Registration order respects navOrder: core (0) before finance (10).
export function bootstrapClientModules(): void {
  clientModuleRegistry.register(coreClientModule);
  clientModuleRegistry.register(financeClientModule);
  clientModuleRegistry.register(codeClientModule);

  // Conversation cards: core renderers first (generic), then module overrides
  // scoped to the contributing module's id.
  registerCoreCardRenderers();
  for (const module of clientModuleRegistry.all()) {
    for (const card of module.cards ?? []) {
      registerCardRenderer(card.cardType, card.lazy, module.manifest.id);
    }
    // The side panels a conversation opens its records in (Spec 76 registry). Bootstrap runs once; a hot reload that
    // runs it again finds them registered.
    for (const panel of module.panelTypes ?? []) {
      if (getPanelType(panel.type) === null) registerPanelType(panel);
    }
  }
}
